define('persistence/dataProviders/signupDataProvider',['externalDependencies/clientWebSocket',
    'common/promises/promiseFactory'],
function() {
    return function() {
        let self = this;
        let _promiseFactory = null;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');

        let clientWebSocket = require('externalDependencies/clientWebSocket');

        self.getById = (signupSessionId, secretKey) => {
            return _promiseFactory.defer((promise) => {
                const request = {
                    signupSessionId: signupSessionId,
                    secretKey: secretKey
                };

                clientWebSocket.sendUnAuthenticated("signup", "getSignupSession", request, (response) => {
                    promise.resolve(response);
                });
            });
        };

        self.connectSocket = (signupSessionId, secretKey) => _promiseFactory.defer(promise => {
            const request = {
                signupSessionId: signupSessionId,
                secretKey: secretKey
            };

            clientWebSocket.sendUnAuthenticated("signup", "connectWebsocket", request, (response) => {
                promise.resolve(response);
            });
        });

        self.getAffiliates = (signupSessionId, secretKey) => _promiseFactory.defer((promise) => {
            const request = {
                signupSessionId: signupSessionId,
                secretKey: secretKey
            };

            clientWebSocket.sendUnAuthenticated("signup", "getAffiliates", request, (response) => {
                promise.resolve(response);
            });
        });

        self.getBillingPackages = (signupSessionId, secretKey) => {
            return _promiseFactory.defer((promise) => {
                const request = {
                    signupSessionId: signupSessionId,
                    secretKey: secretKey
                };
                clientWebSocket.sendUnAuthenticated("signup", "getBillingPackages", request, (response) => {
                    promise.resolve(response);
                });
            });
        };

        self.getHubSpotContact = (signupSessionId, secretKey, contactId) => {
            return _promiseFactory.defer((promise) => {
                const request = {
                    signupSessionId: signupSessionId,
                    secretKey: secretKey,
                    hubSpotContactRecordId: contactId
                };
                clientWebSocket.sendUnAuthenticated("signup", "getHubSpotContact", request, (response) => {
                    promise.resolve(response);
                });
            });
        };

        self.getHubSpotContactByEmail = (signupSessionId, secretKey, emailAddress) => {
            return _promiseFactory.defer((promise) => {
                const request = {
                    signupSessionId: signupSessionId,
                    secretKey: secretKey,
                    emailAddress: emailAddress
                };
                clientWebSocket.sendUnAuthenticated("signup", "getHubSpotContactByEmail", request, (response) => {
                    promise.resolve(response);
                });
            });
        };

        self.getOnboardingForms = (signupSessionId, secretKey) => {
            return _promiseFactory.defer((promise) => {
                const request = {
                    signupSessionId: signupSessionId,
                    secretKey: secretKey
                };
                clientWebSocket.sendUnAuthenticated("signup", "getOnboardingForms", request, (response) => {
                    promise.resolve(response);
                });
            });
        };

        self.getPaymentMethod = (signupSessionId, secretKey) => {
            return _promiseFactory.defer((promise) => {
                const request = {
                    signupSessionId: signupSessionId,
                    secretKey: secretKey
                };
                clientWebSocket.sendUnAuthenticated("signup", "getPaymentMethod", request, (response) => {
                    promise.resolve(response);
                });
            });
        };

        self.init = function () {
            _promiseFactory = new PromiseFactoryConstructor();
        };
    };
});
